<template>
  <div class="avue-contail" :class="{'avue--collapse':isCollapse}">
    <template v-if="!isInQiankun">
      <div class="avue-header">
        <!-- 顶部导航栏 -->
        <top ref="top" />
      </div>
      <div class="avue-layout">
        <div class="avue-left">
          <!-- 左侧导航栏 -->
          <sidebar />
        </div>
        <div class="avue-main">
          <!-- 顶部标签卡 -->
          <tags />
          <transition name="fade-scale">
            <search class="avue-view" v-show="isSearch"></search>
          </transition>
          <!-- 主体视图层 -->
          <div class="view-container" id="avue-view" v-show="!isSearch">
            <keep-alive>
              <router-view class="avue-view" v-if="$route.meta.keepAlive" :key="$route.fullPath" />
            </keep-alive>
            <router-view class="avue-view" v-if="!$route.meta.keepAlive" />
          </div>
        </div>
      </div>
      <div class="avue-shade" @click="showCollapse"></div>

    </template>

    <template v-else>
      <div
        class="view-container view-container--embedded"
        id="avue-view"
        v-show="!isSearch"
      >
        <keep-alive>
          <router-view class="avue-view" v-if="$route.meta.keepAlive" :key="$route.fullPath" />
        </keep-alive>
        <router-view class="avue-view" v-if="!$route.meta.keepAlive" />
      </div>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tags from './tags'
import search from './search'
import top from './top/'
import sidebar from './sidebar/'
import admin from '@/util/admin'
import { getRequset } from '@/basic-common/util/common.js'
import website from '@/config/website'

export default {
  components: {
    top,
    tags,
    search,
    sidebar,
  },
  name: 'index',
  provide() {
    return {
      index: this,
    }
  },
  data() {
    return {
      key: true,
      //搜索控制
      isSearch: false,
      //刷新token锁
      refreshLock: false,
      //刷新token的时间
      refreshTime: '',
      isInQiankun:window.__POWERED_BY_QIANKUN__
    }
  },
  created() {

  },
  mounted() {
    this.init()
  },
  computed: mapGetters(['isMenu', 'isLock', 'isCollapse', 'website', 'menu']),
  props: [],
  methods: {
    showCollapse() {
      this.$store.commit('SET_COLLAPSE')
    },
    // 初始化
    init() {
      this.$store.commit('SET_SCREEN', admin.getScreen())
      window.onresize = () => {
        setTimeout(() => {
          this.$store.commit('SET_SCREEN', admin.getScreen())
        }, 0)
      }
      this.$store.dispatch('FlowRoutes').then(() => {})

      //  脱敏数据
      let desensitizeObj = {}
      const { userInfo } = this.$store.state.user
      if (!userInfo.role_name.split(',').includes(website.dictionaryName)) {
        getRequset(
          '/api/blade-system/dict-biz/dictionary?code=desensitize_config'
        ).then(({ data }) => {
          data &&
            data.data.map((res) => {
              desensitizeObj[res.dictValue] = res.dictKey
                ? res.dictKey.split(',')
                : []
            })
          this.$store.commit('Set_Desensitization', desensitizeObj)
        })
      } else {
        this.$store.commit('Set_Desensitization', {})
      }
    },
    //打开菜单
    openMenu(item = {}) {
      this.$store.dispatch('GetMenu', item.id).then((data) => {
        if (data.length !== 0) {
          this.$router.$avueRouter.formatRoutes(data, true)
        }
        //当点击顶部菜单后默认打开第一个菜单
        /*if (!this.validatenull(item)) {
          let itemActive = {},
            childItemActive = 0;
          if (item.path) {
            itemActive = item;
          } else {
            if (this.menu[childItemActive].length === 0) {
              itemActive = this.menu[childItemActive];
            } else {
              itemActive = this.menu[childItemActive].children[childItemActive];
            }
          }
          this.$store.commit('SET_MENU_ID', item);
          this.$router.push({
            path: this.$router.$avueRouter.getPath({
              name: (itemActive.label || itemActive.name),
              src: itemActive.path
            }, itemActive.meta)
          });
        }*/
      })
    },
  },
}
</script>

<style scoped lang="scss">
/* 主体区：不出现外层纵向滚动条，由表格 height 内滚动；顶部留白缩短以利按钮栏贴近查询区 */
.view-container {
  flex: 1 1 auto;
  height: calc(100% - 45px);
  min-height: 0;
  overflow: hidden;
  /* 左右略收窄，减轻表格右侧固定「操作」列与页边的白条间距（原为 24px + avue-view 6px） */
  padding: 10px 10px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.view-container > .avue-view {
  flex: 1 1 auto;
  height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/* 嵌入主应用时无 tags，占满微应用视口高度 */
.view-container--embedded {
  flex: 0 0 auto;
  height: auto;
  min-height: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  height: 90vh;
}

.view-container--embedded > .avue-view {
  height: auto;
  min-height: 100%;
  overflow: visible;
}


</style>
